export default "__VITE_ASSET__m$nsd6jX__";